import queryString from "query-string";
import { useEffect } from "react";
import { connect } from "react-redux";
import { showSuccessFlashMessage } from "../actions/flashMessage";
import { WithRouterProps, withRouter } from "../helpers/RouterHelper";

interface DispatchProps {
  showSuccessFlashMessage: typeof showSuccessFlashMessage;
}

type Props = WithRouterProps & DispatchProps;

const LoginCallback = (props: Props) => {
  const { showSuccessFlashMessage, location, navigate } = props;

  useEffect(() => {
    const { login, ...rest } = queryString.parse(location.search);
    if (login !== "success") {
      return;
    }
    showSuccessFlashMessage("ログインしました");

    // login=successをURLに残したままにすると、このコンポーネントはアプリの
    // ルート直下に常駐していてロケーション変化のたびに再レンダリングされるため、
    // 遷移（タブ/フィルタ操作など）のたびにフラッシュが再発火してしまう。
    // 表示後はloginパラメータのみ取り除き、他のクエリは保持する。
    const search = queryString.stringify(rest);
    navigate(
      { pathname: location.pathname, search: search ? `?${search}` : "" },
      { replace: true },
    );
  }, [location.pathname, location.search, navigate, showSuccessFlashMessage]);

  return null;
};

const mapDispatchToProps = {
  showSuccessFlashMessage,
};

export default withRouter<Props>(
  connect(null, mapDispatchToProps)(LoginCallback),
);
